export default [

    // *--------- PLATFORM --------------------------------*
    {
        path: '/railway-structure/platform/list',
        name: 'railway_structure-platform-list',
        component: () => import('@/views/apps/railway_structure/platform/views/List.vue'),
        meta: {
            resource: 'platform',
            action: 'read',
            pageTitle: 'Платформы',
            breadcrumb: [
                {
                  text: 'Структура ЖД',
                    active: true,
                },
                {
                  text: 'Платформы',
                  active: true,
                },
            ],
        },
    },
    {
        path: '/railway-structure/platform/view/:id',
        name: 'railway_structure-platform-view',
        component: () => import('@/views/apps/railway_structure/platform/views/Details.vue'),
        meta: {
            resource: 'railway',
            action: 'read',
            pageTitle: 'Платформы',
            breadcrumb: [
                {
                    text: 'Структура ЖД',
                    active: true,
                },
                {
                    text: 'Платформы',
                    to: {
                        name: 'railway_structure-platform-list'
                    }
                },
                {
                    text: 'Детали',
                    active: true
                },
            ],
        },
    },
]
